// RoomLights
// Features:
// - Emissive meshes for ceiling lights and exterior light
// - Toggles intensity/color based on global light state

import { useMemo } from 'react'
import * as THREE from 'three'

import { useStore } from '../../store/useStore'

const LIGHTS_CONFIG = {
    intensity: 5.39,
    color: new THREE.Color('#df9b34'),
    colorOff: new THREE.Color('#aa846b'),
}

export default function RoomLights({ nodes }) {
    const lightsOn = useStore((state) => state.lightsOn)

    // Material for the exterior light (always on)
    const lightMaterial = useMemo(() => {
        return new THREE.MeshStandardMaterial({
            color: LIGHTS_CONFIG.color,
            emissive: LIGHTS_CONFIG.color,
            emissiveIntensity: LIGHTS_CONFIG.intensity,
        })
    }, [])

    // Material for roof lights (toggled)
    const roofLightsMaterial = useMemo(() => {
        const col = lightsOn ? LIGHTS_CONFIG.color : LIGHTS_CONFIG.colorOff
        const emi = lightsOn ? LIGHTS_CONFIG.intensity : 1.0

        return new THREE.MeshStandardMaterial({
            color: col,
            emissive: col,
            emissiveIntensity: emi,
        })
    }, [lightsOn])

    return (
        <group>
            {/* Roof Lights (Interior) */}
            <mesh
                geometry={nodes.light_roof.geometry}
                material={roofLightsMaterial}
                position={[1.314, 3.659, 2.286]}
            />

            {/* Exterior Light */}
            <mesh
                geometry={nodes.light_out.geometry}
                material={lightMaterial}
                position={[3.552, 2.86, 1.126]}
            />
        </group>
    )
}
